<template>
  <multiselect
    :options="filterGroups"
    :searchable="true"
    :internal-search="false"
    :option-height="104"
    :loading="isSearching"
    :options-limit="50"
    :reset-after="false"
    :show-labels="false"
    :multiple="true"
    :value="filterGroup"
    track-by="id"
    label="title"
    placeholder="Επιλέξτε ομάδα φίλτρων..."
    select-label="Πατήστε enter για επιλογή"
    @search-change="searchFilterGroups"
    @select="selectFilterGroup"
    @remove="handleRemove"
  >
    <template v-slot:option="props" class="option">
      <div class="option__desc">
        <span class="option__title">{{ props.option.title }}</span>
      </div>
    </template>
    <template v-slot:noResult>
      Δε βρέθηκαν αποτελέσματα. Προσπαθήστε ξανά!!
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import debounce from 'lodash/debounce';
import request from '@/utils/request';

export default {
  inject: ['$validator'],
  components: {
    Multiselect,
  },
  props: {
    filterGroup: Array,
  },
  data() {
    return {
      filterGroups: [],
      isSearching: false,
    };
  },
  methods: {
    // eslint-disable-next-line func-names
    searchFilterGroups: debounce(async function(searchQuery) {
      if (searchQuery.length) {
        this.isSearching = true;
        const { data } = await request.get('/filterGroups-search', {
          params: {
            term: searchQuery,
          },
        });
        this.isSearching = false;

        this.filterGroups = data.filterGroups;
      }
    }, 300),
    selectFilterGroup(selectedOption) {
      this.$emit('select-filter-group', selectedOption);
    },
    handleRemove(selectedOption) {
      this.$emit('remove-filter-group', selectedOption);
    },
  },
};
</script>

<style scoped lang="scss">
.multiselect {
  margin: 0 auto;
}
</style>
